import { render, staticRenderFns } from "./ProtocolCard.vue?vue&type=template&id=a53e92f4"
import script from "./ProtocolCard.vue?vue&type=script&lang=js"
export * from "./ProtocolCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports